const ITEMS = [
  "Umbondo",
  "Ingqibamasondo ka MaMdineka",
  "26 September 2026",
  "The Mbele Family",
  "Mullerstuine · Vanderbijlpark",
  "Umndeni wakhiwa ngothando",
];

const Diamond = ({ plum }) => (
  <span
    className={`mx-8 inline-block h-2 w-2 rotate-45 ${
      plum ? "bg-[#8E6A8E]" : "bg-[#C5A059]"
    }`}
  />
);

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${key}-${item}`} className="flex items-center">
          <span className="whitespace-nowrap font-serif-lux text-lg italic tracking-wide text-[#E8D8B0] sm:text-xl">
            {item}
          </span>
          <Diamond plum={i % 2 === 1} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee"
      className="marquee border-y border-[#C5A059]/30 bg-[#4A3B32] py-5"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
